import React from "react";
import ProfileAdmin from "../../containers/Admin/ProfileAdmin";
import { Wrap } from "../../components/Layout/Page";

// Scene wrapper is just for consistency.
// This is a legacy view that will be rewritten
const UserProfileScene = () => (
  <Wrap>
    <ProfileAdmin />
  </Wrap>
);

export default UserProfileScene;
